import { _ as _defineProperty } from '../../unsorted/defineProperty.js';
import { useCallback, useMemo, useId, cloneElement, useEffect } from 'react';
import { m as merge } from '../../unsorted/index.js';
import { _ as _objectWithoutProperties } from '../../unsorted/objectWithoutProperties.js';
import { jsx } from '@emotion/react/jsx-runtime';
import '@emotion/react';
import { u as useOverlaysStore, a as CLOSE_MODAL, c as UPDATE_MODAL_PROPS, b as OPEN_MODAL } from '../../providers/overlaysContext/overlaysContext.js';
import { B as Box } from '../Box/Box.js';
import { useTheme } from '../../hooks/useTheme.js';
import { M as ModalTarget } from '../ModalTarget/ModalTarget.js';
import { S as SmartClone } from '../SmartClone/SmartClone.js';
import { useGetSubcomponentChild } from '../../hooks/useGetSubcompnentChild.js';
import { useForwardLocalDomRef } from '../../hooks/useForwardLocalDomRef.js';
import { useControlledOverlay } from '../../hooks/useControlledOverlay.js';

var _excluded = ["children", "id", "sx", "className"];
function ownKeys$1(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function ModalContent(_ref) {
  var _theme$components2;
  var children = _ref.children,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? "" : _ref$id,
    _ref$sx = _ref.sx,
    sx = _ref$sx === void 0 ? {} : _ref$sx,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useOverlaysStore = useOverlaysStore(function (state) {
      return state.modalList;
    }),
    dispatchAction = _useOverlaysStore.dispatchAction;
  var theme = useTheme();
  var closeModal = useCallback(function () {
    return dispatchAction({
      type: CLOSE_MODAL,
      payload: {
        id: id
      }
    });
  }, [dispatchAction, id]);
  var renderedChildren = typeof children === "function" ? children({
    closeModal: closeModal
  }) : children;
  var mergedSx = useMemo(function () {
    var _theme$components$Mod, _theme$components;
    return merge({
      maxw: "100dvw",
      maxh: "100dvh",
      minh: "100%",
      overflow: "auto"
    }, (_theme$components$Mod = (_theme$components = theme.components) === null || _theme$components === void 0 || (_theme$components = _theme$components.Modal) === null || _theme$components === void 0 || (_theme$components = _theme$components.ModalContent) === null || _theme$components === void 0 ? void 0 : _theme$components.sxOverride) !== null && _theme$components$Mod !== void 0 ? _theme$components$Mod : {}, sx);
  }, [sx, (_theme$components2 = theme.components) === null || _theme$components2 === void 0 || (_theme$components2 = _theme$components2.Modal) === null || _theme$components2 === void 0 || (_theme$components2 = _theme$components2.ModalContent) === null || _theme$components2 === void 0 ? void 0 : _theme$components2.sxOverride]);
  return jsx(Box, _objectSpread$1(_objectSpread$1({}, props), {}, {
    sx: mergedSx,
    className: "".concat(className !== null && className !== void 0 ? className : "", " ModalContent"),
    children: renderedChildren
  }));
}
ModalContent.displayName = "Modal.Content";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function Modal(_ref) {
  var _ref2, _theme$globalConfig, _theme$components2;
  var visible = _ref.visible,
    idProp = _ref.id,
    children = _ref.children,
    _ref$domRef = _ref.domRef,
    domRef = _ref$domRef === void 0 ? {
      current: null
    } : _ref$domRef,
    onCloseModal = _ref.onCloseModal,
    _ref$showBgOverlay = _ref.showBgOverlay,
    showBgOverlay = _ref$showBgOverlay === void 0 ? true : _ref$showBgOverlay,
    _ref$bgOverlaySx = _ref.bgOverlaySx,
    bgOverlaySx = _ref$bgOverlaySx === void 0 ? {} : _ref$bgOverlaySx,
    fullScreenUntilBreakpoint = _ref.fullScreenUntilBreakpoint,
    _ref$outsideClicksClo = _ref.outsideClicksClose,
    outsideClicksClose = _ref$outsideClicksClo === void 0 ? true : _ref$outsideClicksClo,
    _ref$escapeKeyClose = _ref.escapeKeyClose,
    escapeKeyClose = _ref$escapeKeyClose === void 0 ? true : _ref$escapeKeyClose,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? {
      x: "center",
      y: "center"
    } : _ref$position,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? "modal" : _ref$testId,
    _ref$ContentSubcompon = _ref.ContentSubcomponent,
    ContentSubcomponent = _ref$ContentSubcompon === void 0 ? ModalContent : _ref$ContentSubcompon,
    className = _ref.className,
    motionProfile = _ref.motionProfile,
    _ref$motionPattern = _ref.motionPattern,
    motionPattern = _ref$motionPattern === void 0 ? "scaleWithBounce" : _ref$motionPattern;
  var theme = useTheme();
  var motionProfileToUse = (_ref2 = motionProfile !== null && motionProfile !== void 0 ? motionProfile : theme === null || theme === void 0 || (_theme$globalConfig = theme.globalConfig) === null || _theme$globalConfig === void 0 ? void 0 : _theme$globalConfig.motionProfile) !== null && _ref2 !== void 0 ? _ref2 : "gentle";
  // @@NOTE: Move domRef to the Target element, by doing:
  // const localDomRef = useForwardLocalDomRef(target?.props?.domRef || { current: null });
  var target = useGetSubcomponentChild(children, ModalTarget);
  var localDomRef = useForwardLocalDomRef(domRef);
  var fallbackId = useId();
  var id = idProp !== null && idProp !== void 0 ? idProp : fallbackId;
  var content = useGetSubcomponentChild(children, ContentSubcomponent);
  var _useOverlaysStore = useOverlaysStore(function (state) {
      return state.modalList;
    }),
    modalList = _useOverlaysStore.state,
    dispatchAction = _useOverlaysStore.dispatchAction;
  var isControlled = useMemo(function () {
    return typeof visible !== "undefined";
  }, [visible]);
  var mergedBgOverlaySx = useMemo(function () {
    var _theme$components$Mod, _theme$components;
    return merge((_theme$components$Mod = (_theme$components = theme.components) === null || _theme$components === void 0 || (_theme$components = _theme$components.Modal) === null || _theme$components === void 0 ? void 0 : _theme$components.bgOverlaySxOverride) !== null && _theme$components$Mod !== void 0 ? _theme$components$Mod : {}, bgOverlaySx);
  }, [bgOverlaySx, (_theme$components2 = theme.components) === null || _theme$components2 === void 0 || (_theme$components2 = _theme$components2.Modal) === null || _theme$components2 === void 0 ? void 0 : _theme$components2.bgOverlaySxOverride]);
  var modalProps = useMemo(function () {
    return {
      id: id,
      content: content ? /*#__PURE__*/cloneElement(content, {
        id: id
      }) : null,
      targetRef: localDomRef,
      showBgOverlay: showBgOverlay,
      isControlled: isControlled,
      onCloseModal: onCloseModal,
      escapeKeyClose: escapeKeyClose,
      outsideClicksClose: outsideClicksClose,
      bgOverlaySx: mergedBgOverlaySx,
      fullScreenUntilBreakpoint: fullScreenUntilBreakpoint,
      position: position,
      testId: testId,
      motionProfile: motionProfileToUse,
      motionPattern: motionPattern
    };
  }, [content, fullScreenUntilBreakpoint, id, isControlled, localDomRef, mergedBgOverlaySx, onCloseModal, outsideClicksClose, escapeKeyClose, position, showBgOverlay, testId, motionProfileToUse, motionPattern]);

  // @NOTE: this useEffect allows the Modal props to stay up to date,
  // as the application re-renders and things potentially change
  useEffect(function () {
    dispatchAction({
      type: UPDATE_MODAL_PROPS,
      payload: modalProps
    });
  }, [dispatchAction, modalProps]);
  var closeModal = useCallback(function () {
    dispatchAction({
      type: CLOSE_MODAL,
      payload: {
        id: id
      }
    });
    onCloseModal === null || onCloseModal === void 0 ? void 0 : onCloseModal();
  }, [dispatchAction, onCloseModal, id]);
  var showModal = useCallback(function () {
    dispatchAction({
      type: OPEN_MODAL,
      payload: modalProps
    });
  }, [dispatchAction, modalProps]);

  // @NOTE: Allow Modal to be controlled:
  useControlledOverlay({
    id: id,
    visible: visible,
    showFunction: showModal,
    hideFunction: closeModal,
    overlayList: modalList
  });
  var onClickProps = useMemo(function () {
    return !isControlled ? {
      onClick: function onClick() {
        if (modalList.find(function (modal) {
          return modal.id === id;
        })) {
          closeModal();
        } else {
          showModal();
        }
      }
    } : {};
  }, [modalList, isControlled, id, closeModal, showModal]);
  return target ? jsx(SmartClone, _objectSpread(_objectSpread({}, onClickProps), {}, {
    id: id,
    domRef: localDomRef,
    testId: testId,
    className: "".concat(className !== null && className !== void 0 ? className : "", " ModalTarget"),
    children: target
  })) : null;
}
Modal.displayName = "Modal";
Modal.Content = ModalContent;
Modal.Target = ModalTarget;

export { Modal as M, ModalContent as a };
//# sourceMappingURL=Modal.js.map
